import { StyleSheet } from 'aphrodite';

export const styles = StyleSheet.create({
  select: {
    width: '100%',
    height: 40,
    marginBottom: 20,
  },
});
